var map = {
	"./atac/logo.png": "42cd",
	"./lantuxs/logo.png": "d1e2",
	"./phadcalc/logo.png": "895e",
	"./yh/logo.png": "13be",
	"./yv/logo.png": "688b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "45d2";